import React from "react";
import Lists from "./Lists/Lists";
import { Container } from "@mui/material";

const CcpAdminUsers = () => {
  return (
    <Container maxWidth="lg" style={{ marginTop: "100px" }}>
      <Lists />
    </Container>
  );
};

export default CcpAdminUsers;
